/* eslint-disable */
import { Quill } from "vue2-editor";
import BlotFormatter from 'quill-blot-formatter';
// import { ImageDropAndPaste } from '@/plugins/quill-editor-custom/imageDropAndPaste';
import QuillImageDropAndPaste from 'quill-image-drop-and-paste'

let SizeStyle = Quill.import('attributors/style/size');
let BaseImageFormat = Quill.import('formats/image');
let BaseVideoFormat = Quill.import('formats/video');
const ImageFormatAttributesList = [
  'alt',
  'height',
  'width',
  'style'
];

class ImageFormat extends BaseImageFormat {
  static formats(domNode) {
    return ImageFormatAttributesList.reduce(function(formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

class VideoFormat extends BaseVideoFormat {
  static formats(domNode) {
    return ImageFormatAttributesList.reduce(function(formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(ImageFormat, true);
Quill.register(VideoFormat, true);
Quill.register(SizeStyle, true);

Quill.register('modules/blotFormatter', BlotFormatter);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);



// WEBPACK FOOTER //
// ./src/plugins/vue-quill-editor.js